import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox } from '@crm-framework/checkbox';

import { getNotificationData } from '../../selectors';
import { notificationsActions } from '../../NotificationsStore';

import { IGridSingleSelectCheckboxProps } from './types';

export const GridSingleSelectCheckbox: React.FC<
  IGridSingleSelectCheckboxProps
> = ({ id }) => {
  const dispatch = useDispatch();

  const { selectedIds } = useSelector(getNotificationData);

  const onChange = useCallback(
    (isChecked: boolean) => {
      if (isChecked) {
        const ids = [...selectedIds, id];
        dispatch(notificationsActions.setSelectedIds({ ids }));
      } else {
        const ids = selectedIds.filter((selectedId) => selectedId !== id);
        dispatch(notificationsActions.setSelectedIds({ ids }));
      }
    },
    [dispatch, id, selectedIds]
  );

  return <Checkbox checked={selectedIds.includes(id)} onChange={onChange} />;
};
